'use client';

import React, { useId, useRef } from 'react';
import { useTranslations } from 'next-intl';
import { useFocusTrap } from 'hooks/dom/useFocusTrap';
import {
  DEFAULT_IMAGE_CARD_MODAL_FIT,
  type ImageCardModalProps,
} from './constants';
import styles from './index.module.css';

export const ImageCardModal = ({
  image,
  imageFit = DEFAULT_IMAGE_CARD_MODAL_FIT,
  title,
  subtitle,
  actions,
  onClose,
}: ImageCardModalProps) => {
  const t = useTranslations('common');
  const titleId = useId();
  const cardRef = useRef<HTMLDivElement>(null);

  useFocusTrap(cardRef, { onEscape: onClose });

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        ref={cardRef}
        className={styles.card}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={
            imageFit === 'fill'
              ? `${styles.imagePanel} ${styles.imagePanelFill}`
              : styles.imagePanel
          }
        >
          <button
            type="button"
            className={
              imageFit === 'fill'
                ? `${styles.closeButton} ${styles.closeButtonOnPhoto}`
                : styles.closeButton
            }
            onClick={onClose}
            aria-label={t('modal.button.ariaLabel.close')}
          >
            {imageFit === 'fill' ? (
              <svg
                className={styles.closeIcon}
                aria-hidden="true"
                viewBox="0 0 12 12"
              >
                <path
                  d="M2.5 2.5L9.5 9.5M9.5 2.5L2.5 9.5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <img src="/Close.svg" alt="" width={32} height={32} />
            )}
          </button>
          {image}
        </div>
        <div className={styles.copyBlock}>
          <h2 className={styles.title} id={titleId}>
            {title}
          </h2>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          <div className={styles.actions}>{actions}</div>
        </div>
      </div>
    </div>
  );
};
